export*from"@pleo-io/telescope-global-style";export*from"@pleo-io/telescope-theme";import Br,{css as Ke}from"styled-components";import{flexbox as Sr,space as Tr}from"styled-system";var wr=["left","center","right"],Mr={left:"flex-start",center:"center",right:"flex-end"},Lr=["top","center","bottom"],Hr={top:"flex-start",center:"center",bottom:"flex-end"},Ar=t=>t.wrap&&Ke`
        flex-wrap: wrap;
    `,Dr=t=>t.stretchChildren&&Ke`
        & > * {
            width: 100%;
        }
    `,I=Br.div.withConfig({shouldForwardProp:(t,o)=>!["alignX","alignY","space","wrap"].includes(t)&&o(t)}).attrs(({align:t="",alignX:o,alignY:r,space:n,...i})=>({alignX:o??t.split(" ")[0],alignY:r??t.split(" ")[1],space:n??0,"data-telescope":i["data-telescope"]??"inline"}))`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: ${({alignY:t="top"})=>Lr.includes(t)?Hr[t]:t};
    justify-content: ${({alignX:t="left"})=>wr.includes(t)?Mr[t]:t};
    box-sizing: border-box;
    
    ${({space:t})=>t&&Ke`
            column-gap: ${t}px;
        `};
    ${Ar}
    ${Dr}
    ${Sr}
    ${Tr}
`;I.displayName="Inline";import L,{forwardRef as Zr}from"react";import{createContext as en,useContext as tn}from"react";import we from"styled-components";import{space as Gr,color as Rr}from"styled-system";import{default as B,__alphaTokens as e,__classNameColorSchemeDark as Os,color as Vs,duration as Es,fontSize as _s,fontWeight as Ws,lineHeight as Ns,opacity as Gs,radius as Rs,shadow as js,spacing as Xs,transition as Qs,zIndex as Ys}from"@pleo-io/telescope-tokens/dist";import{createGlobalStyle as zr}from"styled-components";import d from"@pleo-io/telescope-tokens";import{__classNameColorSchemeDark as Fr}from"@pleo-io/telescope-tokens";var g={colorBackgroundLoading:"var(--colorBackgroundLoading)",colorBackgroundProgressBarShade300:"var(--colorBackgroundProgressBarShade300)",colorContentProgressBarShade900:"var(--colorContentProgressBarShade900)",colorContentProgressBarPink300:"var(--colorContentProgressBarPink300)",colorContentTextShade000:"var(--colorContentTextShade000)",colorContentTextShade600:"var(--colorContentTextShade600)",colorContentTextShade700:"var(--colorContentTextShade700)",colorContentTextShade800:"var(--colorContentTextShade800)",colorContentTextShade900:"var(--colorContentTextShade900)",colorContentTextGreen800:"var(--colorContentTextGreen800)",colorContentTextRed700:"var(--colorContentTextRed700)",colorBackgroundCalloutNeutral:"var(--colorBackgroundCalloutNeutral)",colorBackgroundCalloutError:"var(--colorBackgroundCalloutError)",colorBackgroundCalloutWarning:"var(--colorBackgroundCalloutWarning)",colorBackgroundCalloutSuccess:"var(--colorBackgroundCalloutSuccess)",colorBackgroundCalloutInfo:"var(--colorBackgroundCalloutInfo)",colorBackgroundCalloutDiscovery:"var(--colorBackgroundCalloutDiscovery)",colorBackgroundDatePickerActiveTile:"var(--colorBackgroundDatePickerActiveTile)"},Or={colorBackgroundLoading:{light:d.pink500,dark:d.pink800},colorBackgroundProgressBarShade300:{light:d.shade300,dark:d.shade700},colorContentProgressBarShade900:{light:d.shade900,dark:d.shade000},colorContentProgressBarPink300:{light:d.pink300,dark:d.pink800},colorContentTextShade000:{light:d.shade000,dark:d.shade900},colorContentTextShade600:{light:d.shade600,dark:d.shade500},colorContentTextShade700:{light:d.shade700,dark:d.shade200},colorContentTextShade800:{light:d.shade800,dark:d.shade100},colorContentTextShade900:{light:d.shade900,dark:d.shade000},colorContentTextGreen800:{light:d.green800,dark:d.green600},colorContentTextRed700:{light:d.red700,dark:d.red500},colorBackgroundCalloutNeutral:{light:d.shade200,dark:d.shade700},colorBackgroundCalloutError:{light:d.red200,dark:d.red900},colorBackgroundCalloutWarning:{light:d.yellow300,dark:d.yellow900},colorBackgroundCalloutSuccess:{light:d.green200,dark:d.green900},colorBackgroundCalloutInfo:{light:d.blue200,dark:d.blue900},colorBackgroundCalloutDiscovery:{light:d.purple200,dark:d.purple900},colorBackgroundDatePickerActiveTile:{light:d.shade200,dark:d.shade700}},Mt=t=>zr`
:root {
    ${Object.keys(t).map(o=>`--${o}: ${t[o].light};`)}

    .${Fr} {
        ${Object.keys(t).map(o=>`--${o}: ${t[o].dark};`)}
    }
}
`,Lt=Mt(Or);var Ht=[e.colorBackgroundPresentationalYellow,e.colorBackgroundPresentationalPink,e.colorBackgroundPresentationalGreen,e.colorBackgroundPresentationalBlue,e.colorBackgroundPresentationalPink,e.colorBackgroundPresentationalYellow];function Vr(t){let o=0;for(let r=0;r!==t.length&&!(o>=Number.MAX_SAFE_INTEGER);r++)o+=t.charCodeAt(r);return o}var At=t=>{let o=Vr(t)%Ht.length;return Ht[o]};import{css as M}from"styled-components";var S="3px",Je=e.colorShadowFocus,Te=e.colorShadowFocusInvalid,Ze=M`
    transition: ${e.smoothInOut};
    transition-property: box-shadow;
`,F=M`
    outline: ${S} solid transparent;
`,et=M`
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    box-shadow: 0 0 0 ${S} ${Je};
    ${Ze};
`,Er=M`
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    box-shadow: inset 0 0 0 ${S} ${Je};
    ${Ze};
`,Dt=M`
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    box-shadow: 0 0 0 ${S} ${e.colorBackgroundStatic},
        0 0 0 ${e.spacing6} ${Je};
    ${Ze};
`,_r=M`
    [data-js-focus-visible] &:focus {
        ${F}
    }

    [data-js-focus-visible] &[data-focus-visible-added]:focus {
        ${et}
    }

    [data-js-focus-visible] &[data-focus-visible-added]:focus:invalid {
        /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
        box-shadow: 0 0 0 ${S} ${Te};
    }
`,Wr=M`
    [data-js-focus-visible] &:focus {
        ${F}
        outline-style: inset;
    }

    [data-js-focus-visible] &[data-focus-visible-added]:focus {
        ${Er}
    }

    [data-js-focus-visible] &[data-focus-visible-added]:focus:invalid {
        /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
        box-shadow: inset 0 0 0 ${S} ${Te};
    }
`,Nr=M`
    [data-js-focus-visible] &:focus {
        ${F}
        outline-offset: ${S};
    }

    [data-js-focus-visible] &[data-focus-visible-added]:focus {
        ${Dt}
    }

    [data-js-focus-visible] &[data-focus-visible-added]:focus:invalid {
        /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
        box-shadow: 0 0 0 ${S} ${e.colorBackgroundStatic},
            ${e.spacing6} ${Te};
    }
`,b=t=>t==="inset"?Wr:t==="offset"?Nr:_r,zt=t=>M`
    [data-js-focus-visible] ${t}:focus + & {
        ${F}
        outline-offset: ${S};
    }

    [data-js-focus-visible] ${t}[data-focus-visible-added]:focus + & {
        ${Dt}
    }

    [data-js-focus-visible] ${t}[data-focus-visible-added]:focus:invalid + & {
        /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
        box-shadow: 0 0 0 ${S} ${e.colorBackgroundStatic},
            ${e.spacing6} ${Te};
    }
`;var jr={24:e.fontSmall,40:e.fontMedium,48:e.fontLarge,72:e.font2XLarge},Ft={24:16,40:24,48:24,72:32},Xr={24:1,40:2,48:2,72:3},tt=we.div`
    position: relative;
    display: inline-flex;
    cursor: default;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: ${({$size:t})=>t}px;
    height: ${({$size:t})=>t}px;
    color: ${e.colorContentStatic};
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    font-size: ${({$size:t})=>jr[t]};
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    background-color: ${({$name:t=""})=>At(t)};
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    box-shadow: ${({$outlined:t,$size:o})=>t?`0 0 0 ${Xr[o]}px ${e.colorBackgroundStatic}`:null};
    border-radius: ${e.arc99999};
    ${Rr}
    ${Gr}
`,Ot=we(tt)`
    background: ${e.colorBackgroundStaticLoudest};
`,Vt=we.img.attrs(({$name:t})=>({alt:t}))`
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: ${e.arc99999};
`,Et=we.div`
    ${b("regular")};
    color: ${e.colorContentStatic};
    border: none;
    position: absolute;
    right: ${({$size:t})=>t===72?"-6px":"-8px"};
    bottom: ${({$size:t})=>t===72?"-6px":"-8px"};
    cursor: ${({as:t})=>t==="button"?"pointer":"initial"};
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: ${({$size:t})=>t===72?"32px":"28px"};
    height: ${({$size:t})=>t===72?"32px":"28px"};
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    background-color: ${({$variant:t})=>t==="attention"?e.colorBackgroundPresentationalYellow:e.colorBackgroundStatic};
    border-radius: ${e.arc99999};
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    box-shadow: 0 0 0 3px ${e.colorBackgroundStatic};
`;import{useCallback as Yr,useEffect as qr,useRef as Ur,useState as Kr,useLayoutEffect as Jr}from"react";function _t(t){let{src:o,onLoad:r,onError:n}=t,[i,l]=Kr("pending");qr(()=>{l(o?"loading":"pending")},[o]);let s=Ur(),c=Yr(()=>{if(!o)return;m();let x=new Image;x.src=o,x.onload=v=>{m(),l("loaded"),r?.(v)},x.onerror=v=>{m(),l("failed"),n?.(v)},s.current=x},[o,r,n]),m=()=>{s.current&&(s.current.onload=null,s.current.onerror=null,s.current=null)};return Jr(()=>(i==="loading"&&c(),()=>{m()}),[i,c]),i}var se=48,Wt=en({size:se}),on=Wt.Provider,rn=()=>tn(Wt),Nt=({name:t,src:o,size:r=se,icon:n,getInitials:i=nn,outlined:l,children:s,...c})=>L.createElement(tt,{$name:t,$size:r,$outlined:l,...c,"data-telescope":"avatar"},L.createElement(ln,{name:t,getInitials:i,src:o,icon:n,size:r}),L.createElement(on,{value:{size:r}},s));Nt.displayName="Avatar";function nn(t){let[o,r]=t.toUpperCase().split(" ");return o&&r?`${o.charAt(0)}${r.charAt(0)}`:o.charAt(0)}var an=({name:t,getInitials:o})=>L.createElement("div",{"aria-label":t},t?o?.(t):null),ln=({icon:t,name:o,getInitials:r,src:n,size:i=se})=>{let s=_t({src:n})==="loaded",c=!n||!s;return t?L.cloneElement(t,{role:"img",size:Ft[i]}):c?L.createElement(an,{name:o,getInitials:r}):L.createElement(Vt,{$name:o,src:n})},sn=Zr(({icon:t,as:o="div",variant:r="neutral",...n},i)=>{let{size:l}=rn(),s=L.cloneElement(t,{role:"img",size:16});return L.createElement(Et,{as:o,ref:i,$size:l,$variant:r,...n},s)});Nt.Badge=sn;import ce from"react";import cn from"styled-components";var dn={24:B.spacing6,40:B.spacing12,48:B.spacing14,72:B.spacing24},pn=({$size:t,$stacked:o})=>{let r=dn[t];return o?`-${r}`:r},Gt=cn.div`
    display: flex;

    > *:not(:last-child) {
        margin-right: ${pn};
    }
`;function mn(t){return ce.Children.toArray(t).filter(o=>ce.isValidElement(o))}var yc=({max:t,stacked:o,size:r=se,children:n})=>{let i=mn(n),l=t?i.slice(0,t):i,s=t!==void 0&&i.length-t,c=l.map(m=>ce.cloneElement(m,{size:r,outlined:o}));return ce.createElement(Gt,{$size:r,$stacked:o,"data-telescope":"avatar-group"},c,s>0&&ce.createElement(Ot,{$size:r,$outlined:o,"data-telescope-avatar-excess":!0},"+",s))};import gn from"styled-components";import{border as fn,borderRadius as hn,space as bn}from"styled-system";var G=gn.div.withConfig({}).attrs({"data-telescope":"box"})`
    ${bn}
    ${fn}
    ${hn}
`;G.displayName="Box";import u from"react";import it from"styled-components";import Qt from"react";import R,{css as O}from"styled-components";import{fontDefault as An}from"@pleo-io/telescope-global-style";import{css as Rt}from"styled-components";import{fontDefault as xn}from"@pleo-io/telescope-global-style";var Me=Rt`
    ${b("regular")}
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    font-size: ${({inherit:t})=>t?"inherit":e.fontMedium};
    font-family: ${xn};
    cursor: pointer;
    transition-duration: ${e.smooth};
    transition-property: color;
    appearance: none;
    text-decoration: none;
`,de=Rt`
    color: ${e.colorContentInteractiveLink};

    &:visited {
        color: ${e.colorContentInteractiveLink};
    }

    &:hover,
    &:active {
        color: ${e.colorContentInteractiveLinkHover};
    }
`;import jt from"react";import vn,{keyframes as $n}from"styled-components";import{Spinner as yn}from"@pleo-io/telescope-icons";var Cn=$n`
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
`,kn=vn.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: currentColor;

    svg {
        animation: ${Cn} 1.2s linear infinite;

        @media (prefers-reduced-motion: reduce) {
            animation: none;
        }
    }
`,pe=()=>jt.createElement(kn,{"data-telescope":"spinner"},jt.createElement(yn,{size:16}));pe.displayName="Spinner";import Pn,{css as me}from"styled-components";var In=({truncate:t})=>t&&me`
        white-space: nowrap;
        text-overflow: ellipsis;
    `,Bn=({align:t})=>t&&me`
        text-align: ${t};
    `,Sn=({italic:t})=>t&&me`
        font-style: italic;
    `,Xt=({uppercase:t})=>t&&me`
        text-transform: uppercase;
    `,Tn=({space:t})=>t&&me`
        margin-bottom: ${t}px;
    `,wn=t=>t?Mn[t]:e.fontWeightRegular,Mn={regular:e.fontWeightRegular,medium:e.fontWeightMedium,semibold:e.fontWeightSemibold,bold:e.fontWeightBold},ot=["shade000","shade600","shade700","shade800","shade900","red700","green800","inherit"],K=["shade000","shade600","shade700","shade800","shade900"],ue={"xsmall-subtle":{size:10,color:e.colorContentStaticQuiet,colors:ot,lineHeight:e.lineHeight3,weights:["bold","regular","medium","semibold"]},"small-subtle":{size:12,color:e.colorContentStaticQuiet,colors:ot,lineHeight:e.lineHeight3,weights:["regular","medium","semibold","bold"]},"medium-default":{size:14,color:e.colorContentStatic,colors:ot,lineHeight:e.lineHeight2,weights:["regular","medium","semibold","bold"]},"large-accent":{size:16,color:e.colorContentStatic,colors:K,lineHeight:e.lineHeight2,weights:["regular","medium","semibold","bold"]},"xlarge-accent":{size:18,color:e.colorContentStatic,colors:K,lineHeight:e.lineHeight2,weights:["regular","medium","semibold","bold"]},"2xlarge-accent":{size:20,color:e.colorContentStatic,colors:K,lineHeight:e.lineHeight2,weights:["regular","medium","semibold","bold"]},"3xlarge-accent":{size:24,color:e.colorContentStatic,colors:K,lineHeight:e.lineHeight2,weights:["regular","medium","semibold","bold"]},"4xlarge-accent":{size:32,color:e.colorContentStatic,colors:K,lineHeight:e.lineHeight1,weights:["regular","medium"]},"5xlarge-accent":{size:48,color:e.colorContentStatic,colors:K,lineHeight:e.lineHeight1,weights:["regular","medium"]}},Ln=t=>{switch(t){case"shade000":return g.colorContentTextShade000;case"shade600":return g.colorContentTextShade600;case"shade700":return g.colorContentTextShade700;case"shade800":return g.colorContentTextShade800;case"shade900":return g.colorContentTextShade900;case"green800":return g.colorContentTextGreen800;case"red700":return g.colorContentTextRed700;case"inherit":return"inherit"}};function Hn({color:t,variant:o="medium-default"}){let r=ue[o].color;return t?t==="inherit"?t:ue[o].colors.includes(t)?Ln(t):r:r}var p=Pn.div.attrs(t=>({as:t.as||"div","data-telescope":t["data-telescope"]??"text"}))`
    margin: 0;
    ${Bn}
    ${In}
    ${Tn}
    ${Sn}
    ${Xt}
    color: ${Hn};
    /* stylelint-disable scale-unlimited/declaration-strict-value */
    font-weight: ${({weight:t})=>wn(t)};
    font-size: ${({variant:t="medium-default"})=>ue[t].size}px;
    line-height: ${({variant:t="medium-default"})=>ue[t].lineHeight};
    ${t=>["xsmall-subtle","small-subtle","medium-default"].includes(t.variant??"medium-default")?Xt(t):""};
    /* stylelint-enable */
    i,
    em {
        font-style: italic;
    }

    b,
    strong {
        font-weight: ${e.fontWeightSemibold};
    }
`;p.displayName="Text";var qt=O`
    color: ${e.colorContentInteractiveDisabled};
    background-color: ${e.colorBackgroundInteractiveDisabled};
    cursor: not-allowed;

    &:hover,
    &:focus,
    &:active {
        color: ${e.colorContentInteractiveDisabled};
    }
`,Yt=O`
    color: ${e.colorContentInteractiveInverse};
    background-color: ${e.colorBackgroundInteractiveInverse};

    &:hover,
    &:active {
        color: ${e.colorContentInteractiveInverseHover};
        background-color: ${e.colorBackgroundInteractiveInverseHover};
    }
`,Ut=O`
    color: ${e.colorContentInteractive};
    background-color: ${e.colorBackgroundInteractive};
    border: ${e.sizeBorderThick} solid ${e.colorBorderInteractiveQuiet};

    &:hover,
    &:active {
        color: ${e.colorContentInteractiveHover};
        border-color: ${e.colorBorderInteractiveHover};
    }
`,Dn=O`
    color: ${e.colorContentInteractive};
    background-color: ${e.colorBackgroundInteractive};
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    border: ${e.sizeBorderThickest} solid transparent;

    &:hover,
    &:active {
        color: ${e.colorContentInteractiveHover};
        background-color: ${e.colorBackgroundInteractiveHover};
    }
`,zn=O`
    ${Ut}
    border: none;
    box-shadow: ${e.shadowElevateLoud};

    &:hover,
    &:active {
        background-color: ${e.colorBackgroundInteractiveHover};
    }
`,Kt=O`
    flex: 1;
    width: 100%;
`,Fn=t=>t.disabled?qt:t.variant==="primary"?Yt:t.variant==="secondary"?Ut:t.variant==="raised"?zn:t.variant==="ghost"?Dn:Yt,Jt=O`
    color: ${e.colorContentInteractiveDisabled};
    cursor: not-allowed;

    &:hover,
    &:active {
        color: ${e.colorContentInteractiveDisabled};
    }
`,On=O`
    color: ${e.colorContentInteractiveQuiet};

    &:hover,
    &:active {
        color: ${e.colorContentInteractiveHover};
    }
`,Vn=t=>t.disabled?Jt:t.variant==="link"?de:t.variant==="link-secondary"?On:de,Zt=R.button.withConfig({shouldForwardProp:(t,o)=>!["loading"].includes(t)&&o(t)})`
    ${b("offset")}
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: ${e.spacing8} ${e.spacing32};
    font-weight: ${e.fontWeightRegular};
    font-size: ${e.fontMedium};
    font-family: ${An};
    line-height: ${e.lineHeight1};
    white-space: nowrap;
    border: none;
    text-decoration: none;
    height: ${e.heightInputAndButton};
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    border-radius: ${e.arc99999};
    cursor: pointer;
    transition-duration: ${e.smooth};
    transition-property: background, border, color;
    appearance: none;
    ${Fn};

    [data-telescope='icon'] {
        width: 16px;
        height: 16px;
    }

    ${({fullWidth:t})=>t&&Kt};

    &:disabled {
        ${qt};
    }
`,eo=R.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    text-decoration: none;
    ${Me}
    ${Vn};
    ${({fullWidth:t})=>t&&Kt};
    background: none;
    border: none;

    &:disabled {
        ${Jt};
    }
`,to=R.span`
    display: flex;
    visibility: hidden;
`,oo=R.div`
    position: absolute;
    display: flex;
    align-items: center;
`,En=R.span`
    display: inline-flex;
    color: ${e.colorContentStatic};
`,rt=()=>Qt.createElement(En,null,Qt.createElement(pe,null)),ro=R(p)`
    margin-left: ${e.spacing8};
`,no=R.button.attrs(t=>({type:t.type??"button"}))`
    ${b("regular")}
    margin: 0;
    padding: 0;
    color: inherit;
    font-size: inherit;
    font-family: inherit;
    background: none;
    border: none;
    cursor: pointer;
`;import*as V from"@radix-ui/react-tooltip";import J from"react";import Wn,{keyframes as ge}from"styled-components";import{useElementSize as Nn}from"usehooks-ts";var He="3px",Gn=ge({"0%":{transform:`translateY(${He})`,opacity:0},"100%":{transform:"translateY(0)",opacity:1}}),Rn=ge({"0%":{transform:`translateX(-${He})`,opacity:0},"100%":{transform:"translateX(0)",opacity:1}}),jn=ge({"0%":{transform:`translateY(-${He})`,opacity:0},"100%":{transform:"translateY(0)",opacity:1}}),Xn=ge({"0%":{transform:`translateX(${He})`,opacity:0},"100%":{transform:"translateX(0)",opacity:1}}),Qn=ge({"0%":{opacity:1},"100%":{opacity:0}}),Yn=Wn(V.Content)`
    /* Tooltip content should always be brief. But in case someone is
    unaware of this, we prefer break up text into multiple lines */
    max-width: 40ch;
    padding: ${e.spacing8} ${e.spacing12};
    color: ${e.colorContentStaticInverse};
    font-size: ${e.fontMedium};
    line-height: ${e.lineHeight3};
    background-color: ${e.colorBackgroundStaticInverse};
    border-radius: ${e.arc4};
    box-shadow: ${e.shadowRaiseQuiet};

    /* The content should idealy be shown within 0.1 seconds after
    delay. The fast token is the closest we have to this
    https://ux.stackexchange.com/a/119975 */
    animation-duration: ${e.fast};
    animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);

    &[data-state='delayed-open'] {
        &[data-side='top'] {
            animation-name: ${jn};
        }

        &[data-side='right'] {
            animation-name: ${Xn};
        }

        &[data-side='bottom'] {
            animation-name: ${Gn};
        }

        &[data-side='left'] {
            animation-name: ${Rn};
        }
    }

    &[data-state='closed'] {
        animation-name: ${Qn};
    }
`,Le=14,fe=({children:t,content:o,onOpenChange:r,side:n="top",align:i="center","aria-label":l})=>{let[s,{width:c,height:m}]=Nn();if(!o||o==="")return J.createElement(J.Fragment,null,t);let x=["top","bottom"].includes(n)?c/2-Le/2:m/2-Le/2;return J.createElement(V.Root,{delayDuration:300,onOpenChange:r},J.createElement(V.Trigger,{ref:s,asChild:!0},t),J.createElement(Yn,{side:n,align:i,sideOffset:2,"aria-label":l,"data-telescope":"tooltip"},o,J.createElement(V.Arrow,{fill:e.colorBackgroundStaticInverse,offset:x,width:Le,height:Le/2})))};var nt=t=>t.disabled?"button":t.as?t.as:t.href?"a":"button",qn=t=>{let o="";return u.Children.map(t,r=>{typeof r=="string"&&(o+=r)}),o},io=it(G)`
    display: flex;
    align-items: center;

    [data-telescope='icon'] {
        width: 16px;
        height: 16px;
    }
`,Ae=u.forwardRef((t,o)=>{let{IconLeft:r,IconRight:n}=t,i=u.createElement(u.Fragment,null,r&&u.createElement(io,{mr:8},u.createElement(r,null)),t.children,n&&u.createElement(io,{ml:8},u.createElement(n,null)));return t.variant==="link"||t.variant==="link-secondary"?u.createElement(eo,{...t,as:nt(t),ref:o,"data-telescope":"button"},i):u.createElement(Zt,{type:"button",...t,as:nt(t),ref:o,"data-telescope":"button"},i)}),at=u.forwardRef((t,o)=>t.loading?u.createElement(Ae,{type:"button",as:nt(t),"aria-label":qn(t.children),ref:o,...t,disabled:!0,"data-telescope":"button"},t.loadingText?u.createElement(u.Fragment,null,u.createElement(rt,null),u.createElement(ro,null,t.loadingText)):u.createElement(u.Fragment,null,u.createElement(to,null,t.children),u.createElement(oo,null,u.createElement(rt,null)))):t.tooltipProps?.content&&t.disabled?u.createElement(fe,{...t.tooltipProps},u.createElement(Un,{tabIndex:0},u.createElement(Ae,{...t,ref:o}))):t.tooltipProps?.content?u.createElement(fe,{...t.tooltipProps},u.createElement(Ae,{...t,ref:o})):u.createElement(Ae,{...t,ref:o})),Un=it.div`
    width: fit-content;
    border-radius: ${B.arc20};
    ${b("offset")};
`;at.displayName="Button";var k=no,$d=it(I).attrs({space:16,alignY:"center","data-telescope":"button-group"})``;import{VisuallyHidden as oi}from"@reach/visually-hidden";import H,{forwardRef as ri}from"react";import j,{css as ni}from"styled-components";import{useElementSize as ii}from"usehooks-ts";import{Info as lo,Warning as so,Rocket as ai,Close as li,CircleCheck as si}from"@pleo-io/telescope-icons";import Kn from"styled-components";var ao=Kn.a.attrs({"data-telescope":"link"})`
    ${Me}
    ${de}
`;import Jn from"styled-components";import{space as Zn,flexbox as ei}from"styled-system";var ti={left:"start",center:"center",right:"end"},De=Jn.div.withConfig({shouldForwardProp:(t,o)=>!["align","space"].includes(t)&&o(t)}).attrs(({space:t})=>({space:t??0,"data-telescope":"stack"}))`
    display: grid;
    grid-gap: ${({space:t})=>t}px;
    align-content: start;
    justify-items: ${({stretch:t,align:o="left"})=>t?"stretch":ti[o]};
    box-sizing: border-box;
    width: 100%;

    ${Zn}
    ${ei}
`;De.displayName="Stack";var ci=700,di={neutral:lo,info:lo,warning:so,error:so,success:si,discovery:ai},he=({variant:t="neutral",Icon:o,noIcon:r,children:n})=>{let[i,{width:l}]=ii(),s=!r&&(o??di[t]);return H.createElement(ui,{ref:i,$variant:t,$width:l,"data-telescope":"callout"},H.createElement(oi,null,`${t} callout`),s&&H.createElement(G,{mr:12},H.createElement(s,null)),n)},pi=ri((t,o)=>H.createElement(po,{...t,ref:o},H.createElement(co,null,t.children),H.createElement(hi,null,H.createElement(li,{size:16})))),Yd=({children:t})=>H.createElement(De,{space:16},t),ui=j(I)`
    width: 100%;
    color: ${e.colorContentStatic};
    padding: ${e.spacing8} ${e.spacing8} ${e.spacing8} ${e.spacing12};
    border-radius: ${e.arc8};
    background-color: ${({$variant:t})=>t==="error"?g.colorBackgroundCalloutError:t==="warning"?g.colorBackgroundCalloutWarning:t==="success"?g.colorBackgroundCalloutSuccess:t==="info"?g.colorBackgroundCalloutInfo:t==="discovery"?g.colorBackgroundCalloutDiscovery:g.colorBackgroundCalloutNeutral};

    a,
    ${ao} {
        color: ${e.colorContentInteractive};
        text-decoration: underline;

        &:hover {
            color: ${e.colorContentInteractiveHover};
        }
    }

    ${({$width:t})=>t<ci&&ni`
            ${co} {
                display: none;
            }
            ${po} {
                min-width: 24px;
                margin: 0 ${e.spacing4};
                padding: 0;
                border-radius: ${e.circle};
            }
        `}
`,mi=j(G)`
    flex-grow: 1;
`,gi=j(p)`
    font-weight: 600;
    line-height: ${e.lineHeight3};
`,fi=j(p)`
    flex-grow: 1;

    /* The text is 22px heigh whereas icon and CTA is 24px. This
    is a bit hacky, but we should be safe with any regressions
    as we use Chromatic to do visual diffing. */
    margin-top: 1px;
    margin-right: ${e.spacing4};
`,co=j(p)`
    margin-right: ${e.spacing4};
    line-height: ${e.lineHeight2};
`,hi=j(G)`
    display: flex;
    align-items: center;
`,po=j(k)`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 24px;
    margin-left: ${e.spacing4};
    padding: 0 ${e.spacing8};
    border-radius: ${e.arc4};

    &:hover,
    &:active {
        color: ${e.colorContentInteractiveHover};
        background-color: ${e.shade900lighten10};
    }
`;he.Content=mi;he.ContentHeading=gi;he.Text=fi;he.CloseButton=pi;he.displayName="Callout";import lt,{forwardRef as bi}from"react";import xi,{css as be}from"styled-components";var vi=be`
    ${b("offset")}
    background-color: ${e.colorBackgroundInteractiveInverse};
    color: ${e.colorContentInteractiveInverse};

    &:hover {
        color: ${e.colorContentInteractiveInverseHover};
        background-color: ${e.colorBackgroundInteractiveInverseHover};
    }

    &:disabled {
        background-color: ${e.colorBackgroundInteractive};

        &:hover {
            background-color: ${e.colorBackgroundInteractive};
        }
    }
`,$i=be`
    color: ${e.colorContentInteractiveQuiet};

    &:hover {
        color: ${e.colorContentInteractiveHover};
    }
`,yi=be`
    width: 48px;
    height: 48px;

    [data-telescope='icon'] {
        width: 24px;
        height: 24px;
    }
`,Ci=be`
    width: 32px;
    height: 32px;

    [data-telescope='icon'] {
        width: 16px;
        height: 16px;
    }
`,ki=be`
    width: 24px;
    height: 24px;

    [data-telescope='icon'] {
        width: 16px;
        height: 16px;
    }
`,Pi=bi((t,o)=>lt.createElement(fe,{...t.tooltipProps},lt.createElement(Ii,{"data-telescope":"icon-button",...t,ref:o},lt.createElement(t.Icon,null))));Pi.defaultProps={size:"medium"};var Ii=xi(k)`
    ${b("regular")}
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${e.circle};
    cursor: pointer;
    transition: background-color ${e.smoothInOut}, color ${e.smoothInOut};
    background-color: transparent;
    color: ${e.colorContentInteractive};
    width: ${e.heightInputAndButton};
    height: ${e.heightInputAndButton};

    [data-telescope='icon'] {
        width: 24px;
        height: 24px;
    }

    &:hover {
        color: ${e.colorContentInteractiveHover};
        background-color: ${e.colorBackgroundInteractiveTransparentHover};
    }

    ${t=>t.size==="extraSmall"&&ki}
    ${t=>t.size==="small"&&Ci}
    ${t=>t.size==="large"&&yi}
    ${({variant:t})=>t==="primary"&&vi}
    ${({variant:t})=>t==="quiet"&&$i}

    &:disabled {
        color: ${e.colorContentInteractiveDisabled};
        cursor: not-allowed;

        &:hover {
            background-color: transparent;
        }
    }
`;import ze from"react";import Fe,{css as E}from"styled-components";import{CheckSmall as Bi}from"@pleo-io/telescope-icons";var st=t=>({variant:o})=>o?t[o]:null;var ct=({className:t,variant:o="square",checked:r,disabled:n,children:i,onClick:l,onChange:s=()=>{},...c})=>ze.createElement(Si,{className:t,onClick:l,checked:r,disabled:n},ze.createElement(uo,{checked:r,disabled:n,onChange:s,"aria-invalid":c.isInvalid,...c}),ze.createElement(Ai,{variant:o,disabled:n,checked:!!r,hasLabel:!!i,"data-telescope":"checkbox",$isInvalid:c.isInvalid},ze.createElement(Ti,{variant:o,disabled:n,checked:r})),i);ct.displayName="Checkbox";var Si=Fe(p).attrs({as:"label"})`
    display: inline-flex;
    flex-direction: row;
    justify-content: center;
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    color: ${({disabled:t})=>t?e.colorContentInteractiveDisabled:e.colorContentInteractive};
    cursor: ${({disabled:t})=>t?"not-allowed":"pointer"};

    &:hover:not([disabled]) {
        color: ${e.colorContentInteractiveHover};
    }
`,Ti=Fe(Bi).attrs({size:16})`
    visibility: ${t=>t.checked?"visible":"hidden"};
    fill: none;

    ${st({square:E`
            fill: ${({disabled:t})=>t?e.colorContentInteractiveDisabled:e.colorContentInteractiveSelected};
        `,round:E`
            fill: ${({disabled:t})=>t?e.colorContentInteractiveDisabled:e.colorContentInteractiveSelected};
        `})}
`,uo=Fe.input.withConfig({shouldForwardProp:(t,o)=>!["form"].includes(t)&&o(t)}).attrs({type:"checkbox"})`
    position: absolute;
    width: 1px;
    height: 1px;
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    margin: -1px;
    padding: 0;
    overflow: hidden;
    white-space: nowrap;
    border: none;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
`,wi=({disabled:t,checked:o,$isInvalid:r})=>t?e.colorBorderInteractiveDisabled:r?e.colorBorderNegative:o?e.colorBorderInteractiveSelected:e.colorBorderInteractive,Mi=({disabled:t,checked:o,$isInvalid:r})=>t?e.colorBorderInteractiveDisabled:r?e.colorBorderNegative:o?e.colorBorderInteractiveSelected:e.colorBorderInteractiveLoud,Li=({checked:t,disabled:o,$isInvalid:r})=>o?e.colorBackgroundInteractiveDisabled:r&&t?e.colorBackgroundNegative:t?e.colorBackgroundInteractiveSelected:e.colorBackgroundInteractive,Hi=({checked:t,disabled:o,$isInvalid:r})=>o?e.colorBackgroundInteractiveDisabled:r&&t?e.colorBackgroundNegative:t?e.colorBackgroundInteractiveSelected:e.colorBackgroundInteractive,Ai=Fe.div.withConfig({shouldForwardProp:(t,o)=>!["checked"].includes(t)&&o(t)})`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    margin-top: 1px;
    transition: ${e.fastInOut};
    transition-property: color, border-color, background-color;
    ${zt(uo)}

    &:hover:not([disabled]) {
        ${({checked:t,$isInvalid:o})=>o&&t?E`
                    color: ${e.colorContentInteractiveSelected};
                    background-color: ${e.colorBackgroundNegativeHover};
                    border-color: ${e.colorBorderNegativeHover};
                `:t?E`
                    color: ${e.colorContentInteractiveSelected};
                    background-color: ${e.colorBackgroundInteractiveSelected};
                    border-color: ${e.colorBorderInteractiveHover};

                    > svg {
                        color: ${e.colorContentInteractiveSelected};
                    }
                `:E`
                border-color: ${o?e.colorBorderNegativeHover:e.colorBorderInteractiveHover};
            `}
    }

    ${({hasLabel:t})=>t&&E`
            margin-right: ${e.spacing12};
        `}

    width: 20px;
    height: 20px;
    box-sizing: border-box;

    ${st({square:E`
            background-color: ${Li};
            border: ${e.sizeBorderThick} solid ${wi};
            border-radius: ${e.arc4};
        `,round:E`
            background-color: ${Hi};
            border: ${e.sizeBorderDefault} solid ${Mi};
            border-radius: ${e.circle};
        `})}
`;import ve,{useRef as Gi,useState as Ri}from"react";import ji from"styled-components";import{useEffect as Di,useState as zi}from"react";var mo=(c=>(c.de_DE="de-DE",c.da_DK="da-DK",c.es_ES="es-ES",c.en_IE="en-IE",c.en_GB="en-GB",c.sv_SE="sv-SE",c.fr_FR="fr-FR",c))(mo||{});function go(t="da-DK",o,r){let n=new Intl.NumberFormat(t,{style:o?"currency":"decimal",currency:o}),i=new Intl.NumberFormat(t,{...n.resolvedOptions(),style:"decimal",...r});return l=>l!==null?i.format(l):"-"}var fo=(t,o)=>{let[r,n]=zi(t);return Di(()=>{let i=setTimeout(()=>{n(t)},o);return()=>{clearTimeout(i)}},[o,t]),r};import{useId as Ni}from"@reach/auto-id";import N from"react";import _,{css as dt}from"styled-components";var Fi=e.sizeBorderDefault,Oi=`${parseInt(e.heightInputAndButton)-parseInt(Fi)*2}px`,ho=t=>t.$disabled?e.colorBorderInteractiveDisabled:t.isInvalid?e.colorBorderNegativeHover:e.colorBorderInteractiveHover,bo=_.div`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: ${e.spacing6};
`,Oe=_.input`
    grid-area: input;
    box-sizing: border-box;
    width: 100%;
    height: ${Oi};
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    color: ${t=>t.disabled?e.colorContentInteractiveDisabled:e.colorContentInteractive};
    font-weight: inherit;
    font-size: 14px;
    font-family: inherit;
    text-indent: ${e.sizeBorderDefault};
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    background-color: ${t=>t.disabled?e.colorBackgroundInteractiveDisabled:e.colorBackgroundInteractive};
    border: none;
    outline: none;
    transition: ${e.fastInOut};
    appearance: none;

    &:disabled {
        cursor: not-allowed;
    }

    &:hover {
        /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
        color: ${t=>!t.disabled&&e.colorContentInteractiveHover};
    }

    ::placeholder {
        color: ${e.colorContentInteractivePlaceholder};
    }

    option:disabled {
        color: ${e.colorContentInteractiveDisabled};
    }
`,Hp=_.div``,Ve=_(p).attrs({variant:"medium-default",color:"shade600"})``,xo=_.div`
    grid-area: postfix;
`,vo=_.div`
    grid-area: prefix;
`,Vi=dt`
    border-bottom: ${t=>t.isInvalid?`${e.sizeBorderDefault} solid ${e.colorBorderNegative}`:`${e.sizeBorderDefault} solid ${e.colorBorderInteractiveQuiet}`};

    :focus-within {
        /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
        border-color: transparent;

        ${F};
        /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
        box-shadow: 0 3px 0 0
            ${t=>t.isInvalid?e.colorShadowFocusInvalid:e.colorShadowFocus};
        transition: ${e.smoothInOut};
        transition-property: box-shadow;
    }

    &:hover:not(:focus-within) {
        border-bottom: ${e.sizeBorderDefault} solid ${ho};
    }
`,Ei=dt`
    border: ${t=>t.isInvalid?`${e.sizeBorderDefault} solid ${e.colorBorderNegative}`:"none"};
    border-radius: ${e.arc8};

    :focus-within {
        /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
        border-color: transparent;

        ${F};
        /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
        box-shadow: 0 0 0 3px
            ${t=>t.isInvalid?e.colorShadowFocusInvalid:e.colorShadowFocus};
        transition: ${e.smoothInOut};
        transition-property: box-shadow;
    }

    &:hover:not(:focus-within) {
        border: ${t=>t.isInvalid?`${e.sizeBorderDefault} solid ${e.colorBorderNegativeHover}`:"none"};
    }
`,_i=dt`
    padding-right: ${e.spacing12};
    padding-left: ${e.spacing12};
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    background-color: ${t=>t.$disabled?e.colorBackgroundInteractiveDisabled:e.colorBackgroundInteractive};
    border: ${t=>t.$disabled?`${e.sizeBorderDefault} solid ${e.colorBorderInteractiveDisabled}`:t.isInvalid?`${e.sizeBorderDefault} solid ${e.colorBorderNegative}`:`${e.sizeBorderDefault} solid ${e.colorBorderInteractiveQuiet}`};
    border-radius: ${e.arc8};

    :focus-within {
        /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
        border-color: transparent;

        ${F};
        /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
        box-shadow: 0 0 0 3px
            ${t=>t.isInvalid?e.colorShadowFocusInvalid:e.colorShadowFocus};
        transition: ${e.smoothInOut};
        transition-property: box-shadow;
    }

    &:hover:focus-within {
        /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
        border-color: transparent;
    }

    &:hover:not(:focus-within) {
        border: ${e.sizeBorderDefault} solid ${ho};
    }
`,Wi=({variant:t})=>{switch(t){case"naked":return Vi;case"clean":return Ei;case"bordered":default:return _i}},$o=_.div`
    position: relative;
    display: grid;
    grid-template-areas: 'prefix input postfix';
    grid-template-columns: auto 1fr auto;
    align-items: center;
    overflow: hidden;
    transition: ${e.smoothInOut};
    border: 1px solid transparent;
    ${Wi};
`,W=_(p).attrs({variant:"small-subtle",color:"red700"})`
    text-align: left;
`;var xe=({className:t,postfix:o,prefix:r,isInvalid:n=!1,label:i,renderError:l,renderInput:s,variant:c,innerRef:m,...x})=>{let v=Ni(x.name),f={id:v,"aria-invalid":n,"aria-label":i||void 0};return N.createElement(bo,{className:t,"data-telescope":"input"},i&&N.createElement(Ve,{htmlFor:v,as:"label","data-input-label":!0},i),N.createElement($o,{isInvalid:n,variant:c,$disabled:x.disabled,"data-input-wrapper":!0},N.createElement(vo,{"data-input-prefix":!0},typeof r=="string"?N.createElement(p,{variant:"medium-default",as:"p",color:"shade600"},r):r),s?s(f,x):N.createElement(Oe,{...x,...f,ref:m,"data-input-base":!0}),N.createElement(xo,{"data-input-postfix":!0},typeof o=="string"?N.createElement(p,{variant:"medium-default",as:"p",color:"shade600"},o):o)),l&&l())};xe.displayName="Input";var Xi=ji(Oe)`
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        margin: 0;
        -webkit-appearance: none;
    }

    -moz-appearance: textfield;
`,pt=({currency:t,locale:o="en-GB",formatterConfig:r,...n})=>{let[i,l]=Ri(!1),s=Gi(null),c=fo(i,1),m=n.innerRef||s;m?.current?.addEventListener("wheel",f=>f.preventDefault(),{passive:!1});let x=go(o,t,r),v=n.value;return!(v===""&&n.placeholder)&&!i&&(v=x(Number(n.value))),ve.createElement(xe,{renderInput:(f,ae)=>ve.createElement(ve.Fragment,null,ve.createElement(Xi,{...f,...ae,ref:m,type:c?"number":"text",step:"any",inputMode:"numeric",value:v,onKeyDown:a=>{if(a.key==="ArrowDown"||a.key==="ArrowUp")return a.preventDefault()},onFocus:a=>{l(!0),n.onFocus&&n.onFocus(a)},onBlur:a=>{l(!1),n.onBlur&&n.onBlur(a)},onChange:a=>{!i||n.onChange&&n.onChange(a)},"data-telescope":"currency-input"}),ve.createElement("input",{type:"hidden",name:n.name,value:n.value})),...n})};pt.displayName="CurrencyInput";import ut from"react";import Qi from"react-calendar";import Yi,{css as Ee}from"styled-components";import{ArrowRight as qi,ArrowLeft as Ui}from"@pleo-io/telescope-icons";var Ki=({...t})=>ut.createElement(oa,{nextLabel:ut.createElement(qi,{size:20}),prevLabel:ut.createElement(Ui,{size:20}),prev2Label:null,next2Label:null,minDetail:"decade",showNeighboringMonth:!1,prevAriaLabel:"date-picker-previous",nextAriaLabel:"date-picker-next",...t});Ki.displayName="DatePicker";var yo=-1,$e=40,ko=768,Ji=Ee`
    .react-calendar__navigation__arrow {
        flex-grow: 0;
        justify-content: space-around;
        box-sizing: border-box;
        width: 32px;
        height: 32px;
        color: ${e.colorContentInteractiveQuiet};
        background: none;
        border-radius: ${e.circle};

        &:disabled {
            color: ${e.colorContentInteractiveDisabled};
        }

        &:enabled:hover {
            color: ${e.colorContentInteractiveHover};
            background-color: ${e.colorBackgroundInteractiveHover};
        }
    }

    .react-calendar__navigation__label {
        flex: 1;
        justify-content: space-around;
        margin: 0 ${e.spacing10};
        padding: ${e.spacing6} ${e.spacing12};
        color: ${e.colorContentInteractive};
        font-weight: ${e.fontWeightBold};
        font-size: 14px;
        line-height: ${e.lineHeight1};
        background: none;
        border-radius: ${e.arc8};

        &:enabled:hover {
            color: ${e.colorContentInteractiveHover};
            background-color: ${e.colorBackgroundInteractiveHover};
        }
    }

    .react-calendar__navigation {
        align-items: center;
        justify-content: center;
        margin-bottom: ${e.spacing6};
    }

    @media (min-width: ${ko}) {
        .react-calendar__navigation__label {
            padding: ${e.spacing10} ${e.spacing20};
            font-size: 18px;
        }
    }
`,Zi=Ee`
    .react-calendar__month-view__weekNumbers .react-calendar__tile {
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: ${e.fontWeightBold};
        font-size: 12px;
        border: none;
    }
`,ea=Ee`
    .react-calendar__month-view__weekdays__weekday {
        display: flex;
        align-items: center;
        justify-content: center;
        width: ${$e}px;
        height: ${$e}px;
        color: ${e.colorContentStaticQuiet};
        font-size: 16px;

        abbr {
            text-decoration: none;
            border-bottom: none;
        }
    }
`,ta=Ee`
    .react-calendar__tile {
        position: relative;
        width: ${$e}px;
        max-width: 100%;
        height: ${$e}px;
        margin-top: ${yo}px;
        margin-left: ${yo}px;
        color: ${e.colorContentInteractive};
        background-color: ${e.colorBackgroundInteractive};
        border: 1px solid ${e.colorBorderInteractiveQuiet};
        transition: ${`background-color ${e.fastInOut}`};

        &:disabled {
            color: ${e.colorContentInteractiveDisabled};
            cursor: not-allowed;
        }

        &:focus {
            z-index: ${e.zIndexSurface};
        }

        &:enabled:hover {
            color: ${e.colorContentInteractiveHover};
            background-color: ${e.colorBackgroundInteractiveHover};
        }
    }

    .react-calendar__month-view__days__day--neighboringMonth {
        color: ${e.colorContentInteractiveQuiet};
        border: 1px solid ${e.colorBorderInteractiveQuiet};
    }

    .react-calendar__tile--now {
        font-weight: ${e.fontWeightSemibold};
    }

    .react-calendar__tile--active {
        color: ${e.colorContentInteractive};
        font-weight: ${e.fontWeightMedium};
        background-color: ${g.colorBackgroundDatePickerActiveTile};

        &:enabled:hover {
            color: ${e.colorContentInteractiveHover};
        }
    }

    .react-calendar__tile--hasActive,
    .react-calendar__tile--rangeBothEnds,
    .react-calendar__tile--rangeStart,
    .react-calendar__tile--rangeEnd {
        color: ${e.colorContentInteractiveSelected};
        background-color: ${e.colorBackgroundInteractiveSelected};

        &:enabled:hover {
            color: ${e.colorContentInteractiveSelectedHover};
            background-color: ${e.colorBackgroundInteractiveSelectedHover};
        }
    }
`,Co=t=>20+(t.showWeekNumbers?8:7)*$e,oa=Yi(Qi)`
    width: ${t=>Co(t)}px;
    max-width: 100%;
    font-size: ${e.fontLarge};
    font-family: inherit;

    &,
    & *,
    & *::before,
    & *::after {
        box-sizing: border-box;
    }

    /* For more information: https://github.com/wojtekmaj/react-calendar/issues/462#issuecomment-772388623 */
    .react-calendar__month-view__days__day--neighboringMonth {
        visibility: ${t=>!t.showNeighboringMonth&&"hidden"};
    }

    button {
        margin: 0;
        border: none;
        outline: none;
        font-size: inherit;
        font-family: inherit;
        display: flex;
        justify-content: center;
        align-items: center;
        ${b("inset")}
    }

    button:enabled {
        cursor: pointer;
    }

    ${ea}
    ${Ji}
    ${ta}
    ${Zi}

    @media (min-width: ${ko}px) {
        &.react-calendar--doubleView {
            width: calc(${t=>2*Co(t)}px + ${e.spacing12});
        }

        &.react-calendar--doubleView .react-calendar__viewContainer {
            display: flex;
            margin: -${e.spacing12};

            & > * {
                width: 50%;
                margin: ${e.spacing12};
            }
        }
    }
`;import{useField as ra}from"formik";import na from"react";var ia=({onChange:t,onClick:o,...r})=>{let[{name:n,value:i},,{setTouched:l,setValue:s}]=ra(r);return na.createElement(ct,{...r,name:n,checked:i,onClick:o,onChange:c=>{l(!0),s(c.target.checked),t&&t(c)},"data-telescope":"formik-checkbox"})};ia.displayName="FormikCheckbox";import{ErrorMessage as aa,useField as la}from"formik";import Po from"react";var sa=t=>{let[o]=la(t.name);return Po.createElement(pt,{renderError:()=>Po.createElement(aa,{name:t.name,component:W}),"data-telescope":"formik-currency-input",...o,...t})};sa.displayName="FormikCurrencyInput";import{ErrorMessage as ca,useField as da}from"formik";import Io from"react";var pa=t=>{let[o,r]=da(t.name);return Io.createElement(xe,{isInvalid:!!(r.error&&r.touched),renderError:()=>Io.createElement(ca,{name:t.name,component:W}),"data-telescope":"formik-input",...o,...t})};pa.displayName="FormikInput";import{ErrorMessage as ka,useField as Pa}from"formik";import To from"react";import{useId as ua}from"@reach/auto-id";import Z,{useCallback as Bo,useEffect as So,useRef as ma,useState as ga}from"react";import _e,{css as fa}from"styled-components";var ha=_e.div`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: ${e.spacing6};
    width: 100%;
`,ba=_e.textarea`
    grid-area: input;
    box-sizing: border-box;
    width: 100%;
    min-height: 24px;
    text-indent: 1px;
    color: ${e.colorContentInteractive};
    font-weight: inherit;
    font-size: 14px;
    line-height: ${e.lineHeight2};
    font-family: inherit;
    background-color: ${e.colorBackgroundInteractive};
    border: none;
    outline: none;
    transition: ${e.fastInOut};
    appearance: none;
    resize: none;
    overflow-y: hidden;

    &:hover {
        /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
        color: ${({disabled:t})=>!t&&e.colorContentInteractiveHover};
    }

    ::placeholder {
        color: ${e.colorContentInteractivePlaceholder};
    }

    ${({fixedHeight:t})=>t&&`
            height: ${t};
            overflow-y: auto;
        `}

    ${({disabled:t})=>t&&`
            cursor: default;
            color: ${e.colorContentInteractiveDisabled};
            background-color: ${e.colorBackgroundInteractiveDisabled};

            ::placeholder {
                color: ${e.colorContentInteractiveDisabled};
            }
        `}
`,xa=fa`
    :focus-within {
        /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
        border-color: transparent;

        /* Fallback for Windows High Contrast Mode, as it hides box-shadows */
        /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
        outline: 3px solid transparent;
        /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
        box-shadow: 0 0 0 3px
            ${t=>t.isInvalid?e.colorShadowFocusInvalid:e.colorShadowFocus};
        transition: ${e.smoothInOut};
    }

    :hover:focus-within {
        /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
        border-color: transparent;
    }

    &:hover:not(:focus-within) {
        border: 1px solid
            ${t=>t.isInvalid?e.colorShadowFocusInvalid:e.colorShadowFocus};
    }
`,va=_e.div`
    position: relative;
    display: grid;
    grid-template-areas: 'input postfix';
    grid-template-columns: 1fr auto;
    align-items: center;
    overflow: hidden;
    transition: ${e.smoothInOut};
    padding: ${e.spacing8} ${e.spacing12};
    padding-right: ${e.spacing20};
    border: ${t=>t.disabled?`1px solid ${e.colorBorderInteractiveDisabled}`:t.isInvalid?`1px solid ${e.colorBorderNegative}`:`1px solid ${e.colorBorderInteractiveQuiet}`};
    border-radius: ${e.arc8};
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    background-color: ${t=>t.disabled?e.colorBackgroundInteractiveDisabled:e.colorBackgroundInteractive};

    ${({disabled:t})=>!t&&xa}
`,$a=24,mt=({name:t,onChange:o,showCounter:r=!1,value:n,label:i,className:l,isInvalid:s,renderError:c,maxLength:m,disabled:x,fixedHeight:v,"aria-label":f,...ae})=>{let a=ua(t),[C,wt]=ga(0),w=ma(null),le=Bo(()=>{if(w?.current&&!v){w.current.style.height="";let U=w.current.scrollHeight,Se=Math.max(U,$a);w.current.style.height=Se+"px"}},[v,w]),Be=Bo(()=>{let U=n??w?.current?.value,Se=Number(U?.length);wt(isNaN(Se)?0:Se),le()},[wt,le,n]);So(()=>(window.addEventListener("resize",le),()=>{window.removeEventListener("resize",le)}),[le]),So(()=>{Be();let U=w?.current;return U?.addEventListener("input",Be),()=>U?.removeEventListener("input",Be)},[w,Be]);let Ir=Boolean(m&&n&&n.length>m);return Z.createElement(ha,{className:l,"data-telescope":"textarea"},i&&Z.createElement(Ve,{as:"label",htmlFor:a},i),Z.createElement(va,{isInvalid:s||Ir,disabled:x},Z.createElement(ba,{id:a,name:t,rows:1,"aria-controls":`${a}-counter`,"aria-label":f,value:n===null?"":n,onChange:o,maxLength:m,disabled:x,ref:w,fixedHeight:v,...ae}),r&&Z.createElement(Ca,{id:`counter-${a}`,value:C,maxLength:m})),c&&c())};mt.displayName="Textarea";var ya=_e(p).attrs({role:"status"})`
    position: absolute;
    right: ${e.spacing6};
    bottom: 0;
    font-size: ${e.fontSmall};
`,Ca=({value:t,maxLength:o,id:r})=>{let n=o?o-t:t;return Z.createElement(ya,{id:r},n)};var Ia=t=>{let[o,r]=Pa(t.name);return To.createElement(mt,{isInvalid:!!(r.error&&r.touched),renderError:()=>To.createElement(ka,{name:t.name,component:W}),"data-telescope":"formik-textarea",...o,...t})};Ia.displayName="FormikTextarea";import gt from"styled-components";var Ba=gt.div.attrs(({size:t,color:o})=>({size:t??"1em",mr:12,color:o??e.colorContentStatic}))`
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    margin-top: -0.2em;
    vertical-align: middle;
`;Ba.displayName="ListIcon";var Sa={number:"decimal",bullet:"disc",none:"none"},Ta=gt.ul.attrs({role:"list","data-telescope":"list"})`
    margin: 0;
    padding: 0;
    list-style-position: inside;
    list-style-type: ${({listStyle:t="none"})=>Sa[t]};
`;Ta.displayName="List";var wa=gt.li`
    margin-bottom: ${e.spacing12};
    color: ${e.colorContentStatic};
    font-size: 14px;
    line-height: ${e.lineHeight1};

    &:last-child {
        margin-bottom: ${e.spacing20};
    }
`;wa.displayName="ListItem";import{useId as wo}from"@reach/auto-id";import T from"react";import We,{keyframes as Ma}from"styled-components";import{size as La,space as Mo,height as Ha,width as Aa}from"styled-system";var Ne=({height:t,width:o,size:r,color:n,...i})=>T.createElement(ye,{height:t,width:o,role:"progressbar","aria-live":"polite","data-telescope":"loading",...i},T.createElement(ee,{delay:0,size:r,color:n}),T.createElement(ee,{delay:1,size:r,color:n}),T.createElement(ee,{delay:2,size:r,color:n}));Ne.displayName="Loading";var ft={size:20,color:g.colorBackgroundLoading};Ne.defaultProps=ft;var Lo=({children:t,...o})=>{let r=wo();return T.createElement(za,{"data-telescope":"loading-page"},T.createElement(Ne,{...o,"aria-labelledby":r}),T.createElement(p,{id:r,variant:"medium-default"},t))};Lo.displayName="LoadingPage";Lo.defaultProps={...ft,color:g.colorBackgroundLoading};var Ho=({children:t,...o})=>{let r=wo();return T.createElement(Fa,{"data-telescope":"loading-overlay"},T.createElement(Ne,{...o,"aria-labelledby":r}),T.createElement(p,{id:r,variant:"medium-default"},t))};Ho.displayName="LoadingOverlay";Ho.defaultProps={...ft,color:g.colorBackgroundLoading};var Da=Ma`
    0%,
    80%,
    100% {
        transform: scale3d(0.3, 0.3, 1);
    }

    40% {
        transform: scale3d(1.2, 1.2, 1);
    }
`,ye=We.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    ${Ha}
    ${Aa}
    ${Mo}
`;ye.displayName="Dots";var za=We.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    text-align: center;

    ${ye} {
        padding-top: ${e.spacing60};
        padding-bottom: ${e.spacing60};
    }
`,Fa=We.div`
    position: fixed;
    top: 50%;
    left: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transform: translate(-50%, -50%);

    ${ye} {
        padding-top: ${e.spacing60};
        padding-bottom: ${e.spacing60};
    }
`,ee=We.div`
    display: inline-block;
    margin-right: ${e.spacing20};
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    background-color: ${({color:t})=>t};
    border-radius: ${e.circle};
    animation: ${Da} 1.2s infinite ease-in-out;
    animation-delay: ${({delay:t=0})=>t*160}ms;
    animation-fill-mode: both;
    ${La}
    ${Mo}

    &:last-child {
        margin-right: 0;
    }
`;ee.displayName="Dot";ee.defaultProps={color:e.colorContentStaticQuiet};import Wa from"@reach/visually-hidden";import X from"react";import{Close as Na}from"@pleo-io/telescope-icons";import{DialogOverlay as Oa,DialogContent as Va}from"@reach/dialog";import A,{css as Ao}from"styled-components";var Ea="778px",Do=A.button`
    ${b("inset")};
    position: absolute;
    top: 0;
    right: 0;
    box-sizing: content-box;
    width: 24px;
    height: 24px;
    margin: 0;
    padding: ${e.spacing12};
    background: none;
    border: none;
    border-radius: ${e.arc8};
    cursor: pointer;
`,Ge=Ao`
    padding-right: ${e.spacing40};
    padding-left: ${e.spacing40};

    @media (max-width: ${Ea}) {
        padding-right: ${e.spacing16};
        padding-left: ${e.spacing16};
    }
`,zo=A(p).attrs({variant:"2xlarge-accent",align:"center",as:"h2"})`
    color: ${e.colorContentStatic};
    ${Ge}
`,Fo=A(p).attrs(()=>({variant:"xlarge-accent",align:"center",as:"h3"}))`
    font-size: ${e.fontMedium};
    ${Ge}
`,Oo=A(p).attrs(t=>({as:t.as||"div",variant:"medium-default",align:t.align||"center"}))`
    ${Ge}
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    color: ${({color:t})=>{if(t){if(t==="inherit")return"inherit"}else return e.colorContentStatic;return e[t]}};
`,Vo=A.div`
    display: flex;
    align-items: center;
    justify-content: center;
`,Eo=A.div`
    display: flex;
    justify-content: center;
    margin-bottom: ${e.spacing28};
    ${Ge}
`,_o=A(p).attrs(t=>({as:t.as||"div",variant:"medium-default",align:t.align||"center"}))`
    padding: ${e.spacing20} ${e.spacing40};
    color: ${e.colorContentStaticQuiet};
    font-size: ${e.fontMedium};
    line-height: ${e.lineHeight2};
    background-color: ${e.colorBackgroundStaticLoud};
    border-bottom-right-radius: ${e.arc8};
    border-bottom-left-radius: ${e.arc8};
`,Wo=A(Va)`
    position: relative;
    width: ${({size:t})=>t??"500px"};
    margin: auto;
    padding-top: ${e.spacing24};
    background: ${e.colorBackgroundStatic};
    border-radius: ${e.arc8};
    outline: none;

    ${zo}, ${Fo}, ${Oo}, ${Vo}, ${Eo} {
        margin-bottom: ${e.spacing24};
    }

    ${_o} {
        margin-bottom: 0;
    }

    @media (max-width: 768px) {
        /* TODO agree on breakpoints + mobile first vs desktop first */
        width: 100%;
        margin-top: auto;
        margin-bottom: 0;
    }
`,No=A(Oa)`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    padding: ${e.spacing10};
    overflow: auto;
    background: ${e.colorBackgroundStaticBackdrop};
    backface-visibility: hidden;
    scroll-behavior: smooth;

    ${({$dangerouslySetZIndexValue:t})=>t&&Ao`
            z-index: ${t};
        `}
`;var Go=({onClick:t,children:o,...r})=>X.createElement(Do,{onClick:t,...r},X.createElement(Wa,null,o),X.createElement(Na,{size:24}));Go.displayName="ModalClose";var Ro=({children:t,allowPinchZoom:o,initialFocusRef:r,isOpen:n,onDismiss:i,dangerouslyBypassFocusLock:l,dangerouslyBypassScrollLock:s,dangerouslySetZIndexValue:c,...m})=>X.createElement(No,{isOpen:n,onDismiss:i,allowPinchZoom:o,initialFocusRef:r,dangerouslyBypassFocusLock:l,dangerouslyBypassScrollLock:s,$dangerouslySetZIndexValue:c},X.createElement(Wo,{"aria-label":m["aria-label"],"aria-labelledby":m["aria-labelledby"],...m,"data-telescope":"modal"},t));Ro.displayName="Modal";var Ga=({children:t,...o})=>X.createElement(Ro,{...o},o.onDismiss&&X.createElement(Go,{onClick:o.onDismiss},"Close"),t);Ga.displayName="ModalWithClose";import*as P from"@radix-ui/react-popover";import y from"react";import Za from"styled-components";import{Close as el}from"@pleo-io/telescope-icons";import*as jo from"@radix-ui/react-popover";import Ce,{css as Ra,keyframes as ke}from"styled-components";import{space as ja}from"styled-system";var Re="10px",Xa=ke({"0%":{transform:`translateX(-${Re})`,opacity:0},"100%":{transform:"translateX(0)",opacity:1}}),Qa=ke({"0%":{transform:`translateY(-${Re})`,opacity:0},"100%":{transform:"translateY(0)",opacity:1}}),Ya=ke({"0%":{transform:`translateX(${Re})`,opacity:0},"100%":{transform:"translateX(0)",opacity:1}}),qa=ke({"0%":{opacity:1},"100%":{opacity:0}}),Ua=ke({"0%":{transform:`translateY(${Re})`,opacity:0},"100%":{transform:"translateY(0)",opacity:1}}),Ka=Ra`
    transform-origin: 'var(--radix-popover-content-transform-origin)';

    /* The content should idealy be shown within 0.1 seconds after
    delay. The fast token is the closest we have to this
    https://ux.stackexchange.com/a/119975 */
    animation-duration: ${e.fast};
    animation-timing-function: 'cubic-bezier(0.16, 1, 0.3, 1)';

    &[data-side='top'] {
        animation-name: ${Qa};
    }

    &[data-side='right'] {
        animation-name: ${Ya};
    }

    &[data-side='bottom'] {
        animation-name: ${Ua};
    }

    &[data-side='left'] {
        animation-name: ${Xa};
    }

    &[data-state='closed'] {
        animation-name: ${qa};
    }
`,Xo=Ce.div`
    background-color: ${e.colorBackgroundStatic};

    /* Applying the border directly to the Content component
    causes flickering of the popover Arrow */
    border: ${e.sizeBorderDefault} solid ${e.colorBorderStatic};
    border-radius: ${e.arc8};
    box-shadow: ${e.shadowElevateQuiet};
`,Qo=Ce(jo.Content)`
    width: ${t=>t.$width};
    z-index: ${e.zIndexPopover};
    ${b("regular")};
    ${ja}
    ${Ka}
`,bt=Ce(k)`
    display: inline-flex;
    align-items: center;
    box-sizing: border-box;
    padding: ${e.spacing10};
    color: ${e.colorContentInteractive};
    font-size: ${e.fontMedium};
    line-height: ${e.lineHeight1};

    &:hover {
        color: ${e.colorContentInteractiveHover};
    }

    &:disabled {
        color: ${e.colorContentInteractiveDisabled};
        cursor: not-allowed;
    }
`,ht=12,Yo=Ce.div`
    /* Calculate diagonal distance between corners of the square */
    box-sizing: border-box;
    height: ${ht*Math.sqrt(2)/2}px;
`,qo=Ce.div`
    box-sizing: border-box;
    width: ${ht}px;
    height: ${ht}px;
    background-color: ${e.colorBackgroundStatic};
    border: ${e.sizeBorderDefault} solid ${e.colorBorderStatic};
    transform: translateY(calc(-50% - 1px)) rotate(-45deg);
    clip-path: polygon(0% 0%, 100% 100%, 0% 100%);
`;var $=t=>y.createElement(P.Root,{...t},t.children),tl=t=>y.createElement(P.Trigger,{...t,asChild:!0},t.children),ol=t=>y.createElement(P.Anchor,{...t},t.children);var rl=({matchWidth:t=!1,side:o="bottom",sideOffset:r=2,portalled:n=!0,...i})=>{let l=t?"var(--radix-popover-trigger-width)":"100%",s=n?P.Portal:y.Fragment;return y.createElement(s,null,y.createElement(Qo,{"data-telescope":"popover",...i,side:o,$width:l,arrowPadding:parseInt(e.arc8),sideOffset:r},y.createElement(Xo,null,i.children)))},xt=()=>y.createElement(el,{size:14,mr:"4px"}),nl=t=>y.createElement(P.Close,{...t,asChild:!0},y.createElement(bt,null,y.createElement(xt,null)," ",t.children)),il=bt,al=t=>y.createElement(P.Arrow,{...t,asChild:!0},y.createElement(Yo,null,y.createElement(qo,null))),ll=Za.div`
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    padding: ${e.spacing6};
    background-color: ${e.colorBackgroundStaticLoud};
    border-top: ${e.sizeBorderDefault} solid ${e.colorBorderStatic};
    border-bottom-right-radius: ${e.arc8};
    border-bottom-left-radius: ${e.arc8};
`;$.Trigger=tl;$.Anchor=ol;$.Content=rl;$.Close=nl;$.ActionButton=il;$.Arrow=al;$.ControlsContainer=ll;import sl,{css as je}from"styled-components";var vt="green500",Uo="shade300",cl=t=>{switch(t){case"shade300":return g.colorBackgroundProgressBarShade300;case"none":return"transparent";default:return e[t]}},Ko=t=>{switch(t){case"shade900":return g.colorContentProgressBarShade900;case"pink300":return g.colorContentProgressBarPink300;default:return e[t]}},dl=je`
    height: 10px;

    &::before,
    &::after {
        border-radius: ${e.arc8};
    }
`,pl=je`
    height: 8px;

    &::before {
        border-top-left-radius: ${e.arc8};
        border-bottom-left-radius: ${e.arc8};
    }

    &::after {
        position: absolute;
        top: -2px;
        left: ${({percent:t})=>`${t||"0"}%`};
        display: ${({percent:t})=>t?"block":"none"};
        width: 2px;
        height: 12px;
        /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
        background-color: ${({fillColor:t=vt})=>Ko(t)};
        border-radius: ${e.arc8};
        content: '';
    }
`,ul=je`
    height: 6px;
    border-radius: 0;

    ::before {
        border-radius: 0;
    }
`,Jo=je`
    position: relative;
    width: 100%;
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    background-color: ${({bgColor:t=Uo})=>t==="none"?"transparent":cl(t)};
    border-radius: ${e.arc8};

    &::before {
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: ${({percent:t})=>`${t||"0"}%`};
        height: 100%;
        /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
        background-color: ${({fillColor:t=vt})=>Ko(t)};
        transition-duration: ${e.gradual};
        transition-property: width;
        content: '';
    }
`,ml=t=>t.variant==="slim"?pl:t.variant==="tall"?dl:t.variant==="square"?ul:Jo,gl=(t,o,r)=>Math.min(Math.max(t,o),r),fl=sl.div.attrs(({percent:t,fillColor:o=vt,bgColor:r=Uo})=>{let n=gl(t,0,100);return{role:"progressbar","aria-valuenow":n,"aria-valuemin":0,"aria-valuemax":100,percent:n,fillColor:o,bgColor:r,"data-telescope":"progress-bar"}})`
    ${Jo};
    ${ml};
`;fl.displayName="ProgressBar";import*as te from"@radix-ui/react-radio-group";import Pe from"react";import $t,{css as hl}from"styled-components";var bl=({children:t,defaultValue:o,onValueChange:r,label:n,value:i})=>Pe.createElement(te.Root,{onValueChange:r,defaultValue:o,"aria-label":n,value:i,"data-telescope":"radio-group"},t);bl.displayName="RadioGroup";var xl=({value:t,disabled:o,required:r,label:n})=>Pe.createElement(I,{alignY:"center","data-telescope":"radio-button"},Pe.createElement(vl,{disabled:o,required:r,value:t,id:`id_${t}`},Pe.createElement(er,null)),Pe.createElement($l,{$disabled:o||!1,htmlFor:`id_${t}`},n));xl.displayName="RadioButton";var er=$t(te.Indicator)`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    border-radius: ${e.circle};

    &::after {
        display: block;
        width: 8px;
        height: 8px;
        background-color: ${e.colorContentInteractiveSelected};
        border-radius: ${e.circle};
        content: '';
    }
`,Zo="20px",vl=$t(te.Item)`
    all: unset;
    flex-shrink: 0;
    box-sizing: border-box;
    width: ${Zo};
    height: ${Zo};
    background-color: ${e.colorBackgroundInteractive};
    border: ${e.sizeBorderThick} solid ${e.colorBorderInteractive};
    border-radius: ${e.circle};
    cursor: pointer;
    content: '';

    &:hover:enabled {
        border-color: ${e.colorBorderInteractiveHover};
    }

    &[aria-checked='true'] {
        border-color: transparent;
        background-color: ${e.colorBackgroundInteractiveSelected};
        transition: ${e.fastInOut};
        transition-property: border-color, background-color;
        ${b("offset")}
    }

    &[disabled] {
        background-color: ${e.colorBackgroundInteractiveDisabled};
        border: ${e.sizeBorderDefault} solid ${e.colorBorderInteractiveDisabled};
        cursor: not-allowed;

        &[aria-checked='true'] {
            ${er}::after {
                background-color: ${e.colorContentInteractiveDisabled};
            }
        }
    }
`,$l=$t.label`
    color: ${e.colorContentInteractive};
    user-select: none;
    font-size: ${e.fontMedium};
    padding-left: ${e.spacing12};
    cursor: ${({$disabled:t})=>t?"not-allowed":"pointer"};
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    transition: color ${e.fastInOut};

    &:hover:enabled {
        color: ${e.colorContentInteractiveHover};
    }
    ${t=>t.$disabled&&hl`
            color: ${e.colorContentInteractiveDisabled};
        `}
`;import{Root as yl,TabsContent as Cl,TabsList as kl,Trigger as Pl}from"@radix-ui/react-tabs";import Ie from"react";import Xe from"styled-components";var yt="24px",oe=t=>Ie.createElement(yl,{"data-telescope":"tabs",...t},t.children);oe.displayName="Tabs";var tr=Xe.span`
    margin-left: ${e.spacing12};
    padding: 0 ${e.spacing10};
    color: ${e.colorContentInteractive};
    font-weight: ${e.fontWeightSemibold};
    font-size: ${e.fontSmall};
    line-height: ${yt};
    background-color: ${e.colorBackgroundPresentationalPink};
    border-radius: ${e.arc12};
`,Il=Xe(Pl)`
    display: inline-flex;
    align-items: center;
    margin: 0;
    padding: ${e.spacing16} 0;
    color: ${e.colorContentInteractiveQuiet};
    font-size: ${e.fontMedium};
    font-family: inherit;
    background: none;
    border: none;
    line-height: ${yt};
    cursor: pointer;

    &:visited {
        color: ${e.colorContentInteractiveQuiet};
    }

    &:hover {
        color: ${e.colorContentInteractiveHover};
        border-bottom: ${e.sizeBorderDefault} solid ${e.colorBorderInteractiveHover};
    }

    [data-js-focus-visible] &:focus {
        /* Fallback for Windows High Contrast Mode, as it hides box-shadows */
        /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
        outline: 3px solid transparent;
    }

    [data-js-focus-visible] &[data-focus-visible-added]:focus {
        /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
        box-shadow: inset 0 -4px 0 0 ${e.colorShadowFocus};
        transition: ${e.smoothInOut};
        transition-property: box-shadow;
    }

    border-bottom: 1px solid transparent;

    ${({disabled:t})=>t&&`
        cursor: not-allowed;
        color: ${e.colorContentInteractiveDisabled};
        border-bottom: none;

        &:hover {
            border-bottom: none;
            color: ${e.colorContentInteractiveDisabled};
        }

        ${tr} {
            background-color: ${e.colorBackgroundInteractiveDisabled};
            color: ${e.colorContentInteractiveDisabled};
        }

        `}

    &[aria-selected='true'] {
        color: ${e.colorContentInteractive};
        font-weight: ${e.fontWeightSemibold};
        border-bottom: 1px solid ${e.colorBorderInteractiveSelected};

        &:hover {
            border-bottom: 1px solid ${e.colorBorderInteractiveHover};
        }
    }
`,Bl=Xe.span`
    line-height: ${yt};

    /* See https://css-tricks.com/bold-on-hover-without-the-layout-shift/ */
    ::after {
        display: block;
        height: 0;
        overflow: hidden;
        font-weight: ${e.fontWeightSemibold};
        visibility: hidden;
        content: attr(data-content);
        user-select: none;
        pointer-events: none;

        @media speech {
            display: none;
        }
    }
`,Sl=({text:t,...o})=>Ie.createElement(Bl,{"data-content":t,...o},t),Tl=Xe(kl)`
    display: flex;
    align-items: center;

    > * + * {
        margin-left: ${e.spacing28};
    }
`,or=({children:t,...o})=>Ie.createElement(Tl,{...o},t);or.displayName="TriggerList";var rr=({children:t,...o})=>Ie.createElement(Cl,{...o},t);rr.displayName="Content";var nr=({counter:t})=>Ie.createElement(tr,null,t);nr.displayName="TabsTriggerCounter";oe.Trigger=Il;oe.TriggerText=Sl;oe.TriggerList=or;oe.Content=rr;oe.TriggerCounter=nr;import ne from"react";import{useElementSize as Ml}from"usehooks-ts";import{Close as Ll}from"@pleo-io/telescope-icons";import re,{css as ir}from"styled-components";var Ct={medLayout:700,smallLayout:500},ar=re.div``,lr=re(p).attrs({variant:"xlarge-accent"})`
    margin-bottom: ${e.spacing4};
`,Qe=re(at).attrs({variant:"primary"})`
    align-self: center;
    max-width: fit-content;
`,sr=re(k)`
    position: absolute;
    top: ${e.spacing12};
    right: ${e.spacing12};
    display: flex;
    color: ${e.colorContentInteractive};

    &:hover {
        color: ${e.colorContentInteractiveHover};
    }
`,kt=re.img`
    align-self: flex-start;
    width: 60px;
`,cr=re.div`
    position: relative;
    display: grid;
    grid-template-columns: auto;
    padding-top: ${e.spacing24};
    padding-right: ${e.spacing48};
    padding-bottom: ${e.spacing24};
    padding-left: ${e.spacing24};
    border-radius: ${e.arc8};
    border: ${({$variant:t})=>t==="bordered"?`1px solid ${e.colorBorderStatic}`:"1px solid transparent"};
    gap: ${e.spacing20};
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    background-color: ${({$variant:t})=>t==="secondary"?e.colorBackgroundPresentationalYellow:t==="discreet"?e.colorBackgroundPresentationalGray:t==="bordered"?e.colorBackgroundStatic:e.colorBackgroundPresentationalPink};

    ${({$width:t})=>t>Ct.smallLayout&&t<=Ct.medLayout&&ir`
            ${kt} ~ ${Qe} {
                grid-column-start: 2;
                justify-self: start;
            }
        `}

    ${({$width:t})=>t>Ct.medLayout&&ir`
            display: flex;

            ${Qe} {
                margin-left: auto;
            }
        `}
`;var Hl=t=>ne.createElement(ar,null,t.children),Al=t=>ne.createElement(sr,{"aria-label":t.ariaLabel,...t},ne.createElement(Ll,null)),Dl=t=>ne.createElement(lr,{as:"h2"},t.children),zl=t=>ne.createElement(p,{as:"p"},t.children),Q=t=>{let[o,{width:r}]=Ml();return ne.createElement(cr,{$width:r,ref:o,$variant:t.variant||"primary",role:"status","data-telescope":"banner"},t.children)};Q.Content=Hl;Q.Image=kt;Q.CloseButton=Al;Q.ContentHeading=Dl;Q.ContentText=zl;Q.CTA=Qe;Q.displayName="Banner";import*as pr from"@radix-ui/react-popover";import q from"react";import Y from"react";import Ye from"styled-components";import{ChevronDown as Fl}from"@pleo-io/telescope-icons";var Ol=Ye(k)`
    ${b("offset")}
    display: flex;
    align-items: center;
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    max-width: ${({maxWidth:t})=>t};
    height: 38px;
    padding-top: 0;

    /* For the discreet version, we show a ChevronDown icon which demands less spacing */
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    padding-right: ${({discreet:t})=>t?e.spacing8:e.spacing12};
    padding-bottom: 0;
    padding-left: ${e.spacing12};
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    color: ${({hasAppliedFilters:t})=>t?e.colorContentInteractiveSelected:e.colorContentInteractiveQuiet};
    font-size: ${e.fontMedium};
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    background-color: ${({hasAppliedFilters:t})=>t?e.colorBackgroundInteractiveSelected:e.colorBackgroundInteractive};
    border: ${e.sizeBorderDefault} solid;
    border-color: ${({discreet:t,hasAppliedFilters:o})=>t?"transparent":o?`${e.colorBorderInteractiveSelected}`:`${e.colorBorderInteractiveQuiet}`};
    border-radius: ${e.arc8};
    transition-duration: ${e.smooth};
    transition-property: background-color, border, color;

    &:hover {
        /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
        color: ${({hasAppliedFilters:t})=>t?e.colorContentInteractiveSelectedHover:e.colorContentInteractiveHover};
        /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
        background-color: ${({hasAppliedFilters:t})=>t?e.colorBackgroundInteractiveSelectedHover:e.colorBackgroundInteractive};
        border-color: ${({hasAppliedFilters:t})=>t?e.colorBorderInteractiveSelectedHover:e.colorBorderInteractiveHover};
    }
`,Vl=Ye.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    min-width: 18px;
    height: 18px;
    padding: 0 ${e.spacing4};
    color: ${e.colorContentStatic};
    font-size: ${e.fontSmall};
    background: ${e.colorBackgroundPresentationalPink};
    border-radius: ${e.arc99999};
`,El=Ye.span`
    /* Only takes effect if maxWidth is supplied to the Button */
    overflow: hidden;
    font-size: ${e.fontMedium};
    white-space: nowrap;
    text-overflow: ellipsis;
`,_l=Ye(I).attrs({as:"span",space:6,alignY:"center"})`
    overflow: hidden;
`,dr=Y.forwardRef(({children:t,hasAppliedFilters:o,numAppliedFilters:r,discreet:n,maxWidth:i,loading:l,loadingText:s,...c},m)=>Y.createElement(Ol,{...c,maxWidth:i,hasAppliedFilters:o,discreet:n,ref:m,"data-telescope":"filter-button"},Y.createElement(_l,null,l&&Y.createElement(pe,null),Y.createElement(El,null,l&&s?s:t),o&&!!r&&r>0&&Y.createElement(Vl,null,r),n&&Y.createElement(Fl,{size:16}))));var Wl=({children:t,...o})=>q.createElement(pr.Close,{...o,asChild:!0},q.createElement($.ActionButton,null,t)),Nl=({children:t,...o})=>q.createElement($.ActionButton,{...o},q.createElement(xt,null)," ",t),ie=({children:t,onClose:o,onOpen:r})=>q.createElement($,{onOpenChange:n=>{n&&!!r?r():!n&&o&&o()}},t),Gl=$.Trigger,Rl=$.ControlsContainer,jl=({children:t,align:o="start",...r})=>q.createElement($.Content,{align:o,...r},q.createElement($.Arrow,null),t);ie.Actions=Rl;ie.Apply=Wl;ie.Clear=Nl;ie.Trigger=Gl;ie.Content=jl;ie.Toggle=dr;import Xl from"react";import ur from"styled-components";var Ql=ur.div`
    display: flex;
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    margin-left: ${({separated:t})=>t?"auto":"initial"};

    &:not(:last-child) {
        margin-right: ${B.spacing10};
    }
`,Yl=ur.div`
    display: flex;

    > *:not(:last-child) {
        margin-right: ${B.spacing10};
    }
`,ql=({children:t,...o})=>Xl.createElement(Yl,{"data-telescope":"filter-group",...o},t);ql.Item=Ql;import Pt from"react";import qe,{keyframes as Ul}from"styled-components";import{Close as Kl}from"@pleo-io/telescope-icons";var Jl=Ul`
     0% {
         transform: rotate(0);
         animation-timing-function: cubic-bezier(0.5856,0.0703,0.4143,0.9297)
     }
 
     100% {
         transform: rotate(360deg)
     }
 `,Zl=qe.div`
    box-sizing: border-box;
    width: 20px;
    height: 20px;
    border: 3px solid ${e.colorBackgroundStatic};
    border-top: 3px solid ${e.colorContentStaticQuiet};
    border-radius: ${e.circle};
    animation: ${Jl} 1s infinite linear;
`,es=qe.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    width: 100%;
    padding: ${e.spacing12};
    background-color: ${e.colorBackgroundStaticLoudest};
    border-radius: ${e.arc8};
`,ts=qe(p).attrs({variant:"medium-default",as:"p"})``,os=qe(k)`
    display: flex;
    align-items: center;
    padding: ${e.spacing4} ${e.spacing8} ${e.spacing4} ${e.spacing12};
    color: ${e.colorContentInteractive};
    font-size: ${e.fontMedium};
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    border: 1px solid transparent;
    border-radius: ${e.arc4};
    transition-duration: ${e.smooth};
    transition-property: background, color;

    &:hover {
        color: ${e.colorContentInteractiveHover};
        border: 1px solid ${e.colorBorderInteractiveHover};
    }
`,rs=({children:t,...o})=>Pt.createElement(os,{...o},t,Pt.createElement(Kl,{ml:4,size:20})),It=({children:t,...o})=>Pt.createElement(es,{"data-telescope":"filter-results",...o},t);It.Text=ts;It.Spinner=Zl;It.Clear=rs;import h from"react";import ds,{components as z}from"react-select";import{Close as kr}from"@pleo-io/telescope-icons";import D,{css as mr}from"styled-components";import{Check as ns,ChevronDown as is}from"@pleo-io/telescope-icons";var as=({$hasDescription:t})=>t?mr`
        grid-template-areas:
            'icon label check'
            'description description description';
        grid-template-rows: auto auto;
    `:mr`
            grid-template-areas: 'icon label check';
            grid-template-rows: auto;
        `,ls=({$isFocused:t,$isDisabled:o})=>o?e.colorBackgroundInteractiveDisabled:t?e.colorBackgroundInteractiveHover:e.colorBackgroundInteractive,gr=({$isSelected:t,$isFocused:o,$isDisabled:r})=>r?e.colorContentInteractiveDisabled:t?e.colorContentInteractive:o?e.colorContentInteractiveHover:e.colorContentInteractiveQuiet,fr=D.div`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: ${e.spacing6};
    width: 100%;
    max-width: ${({$maxWidth:t})=>t};

    * {
        box-sizing: border-box;
    }
`,hr=D.div`
    position: relative;
    display: grid;
    font-size: ${e.fontMedium};
    line-height: ${e.lineHeight2};
    ${as};
    grid-template-columns: auto 1fr 16px;
    color: ${gr};
    min-height: auto;
    grid-gap: ${e.spacing8};
    padding: ${e.spacing8} ${e.spacing12} ${e.spacing8} ${e.spacing12};
    cursor: ${({$isDisabled:t})=>t?"not-allowed":"pointer"};
    background-color: ${ls};
`,br=D.span`
    grid-area: description;
    color: ${gr};
    font-size: ${e.fontSmall};
    line-height: ${e.lineHeight1};
`,xr=D(ns)`
    grid-area: check;
    align-self: start;
    justify-self: center;
    margin-top: ${e.spacing2};
`,vr=D.div`
    display: ${({$isDisabled:t})=>t?"none":"flex"};
    align-items: center;
    justify-content: center;
    padding: ${e.spacing4};
    background-color: ${e.colorBackgroundPresentationalPink};
    border-radius: 0 ${e.arc4} ${e.arc4} 0;

    &:focus-within {
        ${et};
    }

    [role='button'] {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        background-color: ${e.colorBackgroundPresentationalPink};
        border-radius: ${e.arc4};
        cursor: pointer;
    }

    [role='button']:hover {
        border: ${e.sizeBorderThick} solid ${e.colorBorderInteractiveHover};
    }
`;function ss(t){return t.$isDisabled?e.colorContentInteractiveDisabled:t.$menuIsOpen?e.colorContentInteractive:e.colorContentInteractiveQuiet}var $r=D(is)`
    color: ${ss};
    transform: ${t=>t.$menuIsOpen?"rotate(180deg)":"rotate(0deg)"};

    &:hover {
        color: ${e.colorContentInteractiveHover};
    }
`,Bt=D.span`
    display: flex;
    align-items: center;

    [data-telescope='icon'] {
        width: 16px;
        height: 16px;
    }
`,yr=D.span`
    grid-area: icon;
    align-self: start;
    justify-self: center;
    margin-top: -${e.spacing2};

    [data-telescope='icon'] {
        width: 16px;
        height: 16px;
    }
`,Ue=D.div`
    overflow: hidden;
    text-overflow: ellipsis;
`;var Cr={alignItems:"center",display:"grid",gridTemplateColumns:"auto 1fr",gridGap:e.spacing8,textAlign:"left",lineHeight:1.5},ps={width:"max-content",minWidth:"100%",maxWidth:"60ch"};function St({label:t,components:o,portalled:r,className:n,isMulti:i,isOptionDisabled:l,closeMenuOnSelect:s=!i,testId:c,maxWidth:m,menuPlacement:x,allowMenuOverflow:v,...f}){let ae=typeof window<"u"&&r;return h.createElement(fr,{className:n,"data-testid":c??"select-wrapper",$maxWidth:m,"data-telescope":"select"},t&&h.createElement(p,{as:"label",color:"shade600",variant:"medium-default",htmlFor:f.name},t),h.createElement(ds,{isDisabled:f.disabled,options:f.options,name:f.name,inputId:f.name,hideSelectedOptions:!1,menuPlacement:x||"auto",menuIsOpen:f.menuIsOpen,menuPortalTarget:r&&ae?document.body:void 0,isMulti:i,closeMenuOnSelect:s,isOptionDisabled:l||(a=>a?.disabled??!1),components:{DropdownIndicator:gs,Option:us,SingleValue:ms,ClearIndicator:fs,MultiValueRemove:xs,Placeholder:hs,MultiValueLabel:bs,...o},styles:{container:a=>({...a,fontSize:e.fontMedium,width:"100%",minWidth:0}),option:()=>({}),groupHeading:a=>({...a,fontWeight:e.fontWeightSemibold,fontSize:e.fontSmall,marginBottom:e.spacing4,color:e.colorContentInteractive,textTransform:"capitalize"}),control:a=>({...a,boxShadow:"none",minHeight:e.heightInputAndButton,border:f.disabled?`${e.sizeBorderDefault} solid ${e.colorBorderInteractiveDisabled}`:f.isInvalid?`${e.sizeBorderDefault} solid ${e.colorBorderNegative}`:`${e.sizeBorderDefault} solid ${e.colorBorderInteractiveQuiet}`,borderRadius:e.spacing8,backgroundColor:f.disabled?e.colorBackgroundInteractiveDisabled:e.colorBackgroundInteractive,"&:hover":{border:f.isInvalid?`${e.sizeBorderDefault} solid ${e.colorBorderNegativeHover}`:`${e.sizeBorderDefault} solid ${e.colorBorderInteractiveHover}`,cursor:f.disabled?"not-allowed":"pointer"},"&:focus-within":{border:f.isInvalid?`${e.sizeBorderDefault} solid ${e.colorShadowFocusInvalid}`:`${e.sizeBorderDefault} solid ${e.colorShadowFocus}`,boxShadow:f.isInvalid?`0 0 0 2px ${e.colorShadowFocusInvalid}`:`0 0 0 2px ${e.colorShadowFocus}`}}),group:a=>({...a,marginTop:e.spacing16,padding:0}),placeholder:(a,C)=>({...a,...Cr,whiteSpace:"nowrap",color:C.isDisabled?e.colorContentInteractiveDisabled:e.colorContentInteractivePlaceholder}),valueContainer:a=>({...a,backgroundColor:"transparent",paddingLeft:e.spacing10}),input:a=>({...a,backgroundColor:"transparent"}),singleValue:(a,C)=>({...a,...Cr,color:C.isDisabled?e.colorContentInteractiveDisabled:e.colorContentInteractive}),multiValue:(a,C)=>({...a,backgroundColor:e.colorBackgroundInteractive,borderRadius:e.arc4,'[role="button"]':{border:C.isFocused?`${e.sizeBorderThick} solid ${e.colorShadowFocus}`:"none"}}),multiValueLabel:(a,C)=>({...a,display:"flex",alignItems:"center",justifyContent:"center",fontSize:e.fontMedium,backgroundColor:C.isDisabled?e.colorBackgroundInteractive:e.colorBackgroundPresentationalPink,color:C.isDisabled?e.colorContentInteractiveDisabled:e.colorContentInteractive,lineHeight:1.5,height:28,paddingLeft:e.spacing8,paddingRight:C.isDisabled?e.spacing8:0,border:C.isDisabled?`${e.sizeBorderDefault} solid ${e.colorBorderInteractiveDisabled}`:"none",borderRadius:C.isDisabled?e.arc4:`${e.arc4} 0 0 ${e.arc4}`}),multiValueRemove:()=>({background:e.colorBackgroundInteractive}),menuList:a=>({...a,padding:0}),menu:a=>({...a,padding:`${e.spacing8} 0`,marginTop:e.spacing8,background:e.colorBackgroundStatic,overflow:"hidden",boxShadow:e.shadowElevateQuiet,border:`${e.sizeBorderDefault} solid ${e.colorBorderStatic}`,borderRadius:e.arc8,...v&&ps}),clearIndicator:a=>({...a,cursor:"pointer",padding:0,color:e.colorContentInteractiveQuiet,"&:hover":{color:e.colorContentInteractiveHover}}),dropdownIndicator:a=>({...a,paddingRight:e.spacing12}),indicatorSeparator:a=>({...a,display:"none"}),indicatorsContainer:a=>({...a})},...f}),f.renderError&&f.renderError())}function us(t){return h.createElement(hr,{...t.innerProps,ref:t.innerRef,$isDisabled:t.data?.disabled??!1,$isSelected:t.isSelected,$isFocused:t.isFocused,$hasDescription:!!t.data.description},t.data?.icon?h.createElement(yr,null,t.data?.icon):null,t.children,t.isSelected&&h.createElement(xr,{size:16,color:e.colorContentInteractive}),t.data.description&&h.createElement(br,{$isSelected:t.isSelected,$isFocused:t.isFocused},t.data.description))}function ms(t){let o;return t.data.icon?o=t.data.icon:t.selectProps.PrefixIcon&&(o=h.createElement(t.selectProps.PrefixIcon,null)),h.createElement(z.SingleValue,{...t},o?h.createElement(Bt,null,o):null,h.createElement(Ue,null,t.children))}function gs(t){return h.createElement(z.DropdownIndicator,{...t},h.createElement($r,{size:16,$isDisabled:t.selectProps.isDisabled,$menuIsOpen:t.selectProps.menuIsOpen}))}function fs(t){return h.createElement(z.ClearIndicator,{...t},h.createElement(kr,{size:16}))}function hs(t){let o=t.selectProps.PrefixIcon;return h.createElement(z.Placeholder,{...t},o&&h.createElement(Bt,null,h.createElement(o,null)),h.createElement(Ue,null,t.children))}function bs(t){return h.createElement(z.MultiValueLabel,{...t},h.createElement(Ue,null,t.children))}function xs(t){return h.createElement(vr,{$isDisabled:t.selectProps.isDisabled},h.createElement(z.MultiValueRemove,{...t},h.createElement(kr,{size:16,color:e.colorContentInteractive})))}var vs=z.Option,$s=z.SingleValue,ys=z.MultiValue;import{ErrorMessage as Cs,useField as ks}from"formik";import Pr from"react";var Ps=t=>{let[o,r,n]=ks(t.name);return Pr.createElement(St,{isInvalid:!!(r.error&&r.touched),renderError:()=>Pr.createElement(Cs,{name:t.name,component:W}),onBlur:i=>{n.setTouched(!0),t.onBlur&&t.onBlur(i)},onChange:(i,l)=>l.action==="clear"&&t.isMulti?n.setValue([]):l.action==="clear"?n.setValue(null):n.setValue(i),value:o.value,"data-telescope":"formik-select",...t})};import Tt from"react";var Yf=({children:t})=>Tt.createElement(Tt.Fragment,null,Tt.createElement(Lt,null),t);export{se as AVATAR_DEFAULT_SIZE,Nt as Avatar,sn as AvatarBadge,yc as AvatarGroup,Q as Banner,W as BaseError,Oe as BaseInput,G as Box,at as Button,$d as ButtonGroup,he as Callout,Yd as CalloutGroup,ct as Checkbox,bo as ComponentWrapper,pt as CurrencyInput,Ki as DatePicker,ee as Dot,ye as Dots,dr as FilterButton,ql as FilterGroup,ie as FilterMenu,It as FilterResults,ia as FormikCheckbox,sa as FormikCurrencyInput,pa as FormikInput,Ps as FormikSelect,Ia as FormikTextarea,Pi as IconButton,I as Inline,xe as Input,Hp as InputContent,$o as InputWrapper,Ve as Label,ao as Link,Ta as List,Ba as ListIcon,wa as ListItem,Ne as Loading,ee as LoadingDot,ye as LoadingDots,Ho as LoadingOverlay,Lo as LoadingPage,mo as Locale,Ro as Modal,Eo as ModalActions,Go as ModalClose,Oo as ModalContent,_o as ModalFooter,Vo as ModalIllustration,Fo as ModalSubtitle,zo as ModalTitle,Ga as ModalWithClose,k as NakedButton,$ as Popover,xt as PopoverCloseIcon,xo as Postfix,vo as Prefix,fl as ProgressBar,xl as RadioButton,bl as RadioGroup,St as Select,ys as SelectMultiValue,vs as SelectOption,$s as SelectSingleValue,pe as Spinner,De as Stack,oe as Tabs,Yf as TelescopeProvider,p as Text,mt as Textarea,fe as Tooltip,e as __alphaTokens,Os as __classNameColorSchemeDark,_i as borderedWrapperVariant,Ei as cleanWrapperVariant,Vs as color,Mt as createCustomColorSchemeTokensGlobalStyle,g as customColorSchemeTokens,Es as duration,b as focusRing,F as focusRingFallbackStyle,Er as focusRingInsetStyle,Dt as focusRingOffsetStyle,et as focusRingRegularStyle,zt as focusRingSibling,_s as fontSize,Ws as fontWeight,qn as getLabelFromChildren,Ns as lineHeight,Vi as nakedWrapperVariant,Gs as opacity,Rs as radius,At as randomColor,js as shadow,Xs as spacing,ue as textVariants,B as tokens,Qs as transition,fo as useDebouncedValue,go as useFormatCurrency,Ys as zIndex};
//# sourceMappingURL=index.js.map